import React from 'react'
import { Input } from 'rebass'

import { formatPhoneNumber } from '../utils/strings'

const formatInput = (value, setFieldValue) =>
  setFieldValue('phoneNumber', formatPhoneNumber(value))

class PhoneInput extends React.PureComponent {
  componentDidMount () {
    formatInput(document.getElementById('phoneNumber').value, this.props.setFieldValue)
  }

  render () {
    const {setFieldValue, ...others} = this.props
    return (
      <Input
        id='phoneNumber'
        type='tel'
        name='phoneNumber'
        {...others}
        onChange={e => formatInput(e.target.value, setFieldValue)}
      />
    )
  }
}

export default PhoneInput


// WEBPACK FOOTER //
// ./src/components/PhoneInput.js